import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierEnterprisePurchaseConditionListPage" */
	'pages/supplier/SupplierEnterprisePurchaseCondition/SupplierEnterprisePurchaseConditionListPage'));

export default [{ component, exact: true, path: '/supplier_enterprise_purchase_conditions' }];